export const ENVIRONMENT = import.meta.env.ENVIRONMENT;
export const PACKAGE_VERSION = import.meta.env.PACKAGE_VERSION;
export const BUILD_ID = import.meta.env.BUILD_ID;
export const APP_API_URL = import.meta.env.APP_API_URL;
export const REPORTS_APP_URL = import.meta.env.REPORTS_APP_URL;
export const ADMIN_APP_URL = import.meta.env.ADMIN_APP_URL;
export const FRESHCHAT_TOKEN = import.meta.env.FRESHCHAT_TOKEN;
export const FRESHCHAT_HOST = import.meta.env.FRESHCHAT_HOST;
export const FRESHCHAT_WIDGET_UUID = import.meta.env.FRESHCHAT_WIDGET_UUID;
export const CHAT_PROVIDER = import.meta.env.CHAT_PROVIDER || "none";
export const SERVICENOW_CHAT_INSTANCE = import.meta.env.SERVICENOW_CHAT_INSTANCE;
export const SERVICENOW_CHAT_MODULE_ID = import.meta.env.SERVICENOW_CHAT_MODULE_ID;
export const SMP_API_URL = import.meta.env.SMP_API_URL;
export const SMP_CLIENT_ID = import.meta.env.SMP_CLIENT_ID;
export const SIMPLE_BASKETBALL_ORG = import.meta.env.SIMPLE_BASKETBALL_ORG;
export const APP_LOGGER_MAX_ENTRIES = import.meta.env.APP_LOGGER_MAX_ENTRIES;

export const APP_TITLE = "Synergy Stats";
